import { USE_CARD_OPTIONS } from "@stadium/checkout/src/constants/cards";
import { USE_CORPORATE_BILLING } from "@stadium/checkout/src/constants/corporate-billing";
import { USE_WALLET_OPTIONS } from "@stadium/checkout/src/constants/wallet";
import { GLOBAL_POINT_PAYMENT_KEY, MY_WALLET_PAYMENT_KEY } from "@stadium/constants/wallets";

export { GLOBAL_POINT_PAYMENT_KEY, MY_WALLET_PAYMENT_KEY };

export const PAYMENT_METHODS = {
  ...USE_CARD_OPTIONS,
  ...USE_CORPORATE_BILLING,
  ...USE_WALLET_OPTIONS,
};
export const DEFAULT_SINGLE_SOURCE_PAYMENT_METHODS = [
  USE_CORPORATE_BILLING.corporateBilled.key,
  USE_WALLET_OPTIONS.useTeamPoint.key,
];

export const MINIMUM_PAYMENT_AMOUNT = 1;
